export default "__VITE_ASSET__d36828b9__"